import angular from 'angular';

export default angular.module('aslicenseModule', [
    'core.ui',
    'ui.router',
    'asDoughnutChart',
    'asEula'
]);



// WEBPACK FOOTER //
// ./modules/aslicense/aslicense.module.js